import { Locales } from "../enums/locales";
export const MEMBERSHIP_IDENTITY_QUESTION_LABELS = {
    [Locales.EN]: { Name: "Full Name", Email: "Email" },
    [Locales.FR]: { Name: "Nom", Email: "Courriel" },
    [Locales.ES]: { Name: "Nombre completo", Email: "Correo electrónico" },
    [Locales.DE]: { Name: "Vollständiger Name", Email: "E-Mail" },
};
export const NOTIFICATION_PHONE_NUMBER_BODY = {
    [Locales.EN]: "Phone Number for Notifications",
    [Locales.FR]: "Numéro de téléphone pour les notifications",
    [Locales.ES]: "Número de teléfono para notificaciones",
    [Locales.DE]: "Telefonnummer für Benachrichtigungen",
};
